<template>
  <el-dialog
    v-drag:common
    title="导入测风塔"
    :visible="visible"
    :show-close="false"
    width="400px"
  >
    <el-form
      :model="formData"
      ref="form"
      class="demo-form-inline"
      :rules="rules"
    >
      <el-form-item label="原始数据" label-width="80px" prop="fileIdOriginal">
        <el-upload
          ref="upload"
          :action="action"
          :data="headers"
          :on-success="onFileUploadSuccess"
          accept=".csv, .rld, .txt, .rwd"
        >
          <ct-button type="primary" size="small">点击上传</ct-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="质控数据" label-width="80px" prop="fileIdValid">
        <el-upload
          ref="upload"
          :action="action"
          :data="headers"
          :on-success="
            (response, file, fileList) =>
              onFileUploadSuccess(response, file, fileList, 'fileIdValid')
          "
          accept=".csv, .rld, .txt, .rwd"
        >
          <ct-button type="primary" size="small">点击上传</ct-button>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="插补数据"
        label-width="80px"
        prop="fileIdInterpolation"
      >
        <el-upload
          ref="upload"
          :action="action"
          :data="headers"
          :on-success="
            (response, file, fileList) =>
              onFileUploadSuccess(
                response,
                file,
                fileList,
                'fileIdInterpolation'
              )
          "
          accept=".csv, .rld, .txt, .rwd"
        >
          <ct-button type="primary" size="small">点击上传</ct-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <ct-button :btn-click="close" size="small" style="margin-right: 10px"
        >取 消</ct-button
      >
      <ct-button type="primary" :btn-click="submit" size="small"
        >确 定</ct-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils';
export default {
  props: ['visible'],
  data() {
    return {
      headers: {
        file: 'file',
        apiKey: getToken(),
      },
      showPassword: false,
      formData: {
        fileIdOriginal: '',
        fileIdValid: '',
        fileIdInterpolation: '',
      },
      ids: [],
      modelNameKeyword: '',
      dataFormatList: [],
      action: `${process.env.VUE_APP_API_HOST_WINDDATA}/windfarm/tower/uploadFile`,
      fileIdValidIds: [],
      fileIdInterpolationIds: [],
      rules: {
        fileIdOriginal: [
          { required: true, message: '请上传原始数据', trigger: 'change' },
        ],
        fileIdValid: [
          { required: true, message: '请上传质控数据', trigger: 'change' },
        ],
        fileIdInterpolation: [
          { required: true, message: '请上传插补数据', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    showPasswordByType() {
      //console.log(this.formData.type, 'this.formData.type...');
      if (this.formData.type === 'rwd' || this.formData.type === 'rld')
        return true;
      return false;
    },
    hrefUrl() {
      return this.formData.type === 'txt'
        ? `${process.env.VUE_APP_TEMPLATE_HOST}/winddata/tower/getTemplateFile?fileName=tower.txt`
        : `${process.env.VUE_APP_TEMPLATE_HOST}/winddata/tower/getTemplateFile?fileName=tower.csv`;
    },
  },
  async mounted() {
    //await this.getDataFormatList();
  },
  methods: {
    close() {
      this.formData = {
        type: '',
        password: '',
      };
      this.$refs.upload.clearFiles();
      this.$emit('close');
    },
    async submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.analysisFile(this.ids.join());
        } else {
          console.log('error submit!!');
          return false;
        }
      });

      // this.$refs.upload.submit();
    },
    async analysisFile(id) {
      const { type, password = '' } = this.formData;
      this.$postForm({
        url: '/windfarm/tower/parseFile',
        module: 'windData',
        data: {
          fileIdOriginal: id,
          formatId: 'txt',
          password,
          projectId: this.$route.query.projectId,
          fileIdValid: this.fileIdValidIds.join(),
          fileIdInterpolation: this.fileIdInterpolationIds.join(),
        },
        showLoading: true,
        showError: true,
        showSuccess: true,
      }).then((res) => {
        if (res.code == 0) {
          this.$emit('close');
          this.formData = {
            ids: '',
            fileIdsOriginalIds: '',
            fileIdsValidIds: '',
          };
          this.ids = [];
          this.$refs.upload.clearFiles();
        }
      });
    },
    async onFileUploadSuccess(response, file, fileList, key) {
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success',
        });
        const { files } = response.data;
        if (key) {
          this[key + 'Ids'].push(
            files
              .map((item) => {
                return item.fileId;
              })
              .join()
          );
          this.formData[key] = this[key + 'Ids'].join();
        } else {
          this.ids.push(
          files
            .map((item) => {
              return item.fileId;
            })
            .join()
        );
        }
       

        this.formData.fileIdOriginal = this.ids.join();
        this.$refs.form.validate();
        //console.log(this.ids, 'ids...');
        return;
      }
      this.$message({
        message: '上传文件失败',
        type: 'error',
      });
    },
    async getDataFormatList() {
      const { data } = await this.$fetch.get(
        '/windfarm/tower/getDataFormatList'
      );
      this.dataFormatList = data.dataFormatList;
    },
  },
};
</script>
<style lang="less" scoped></style>
